module.exports = __webpack_public_path__ + "img/default-person.f9cbc5b3.jpg";